<template>
  <div class="page_content recruiter_reports" aria-label="Recruiter Reports">

    <!--
      <div class="btn_container download_report">
        <button @click="downloadAttemptsAsCsv('ALL')">
          <span class="fa fa-download" aria-hidden="true"></span>
           Constructed Responses
        </button>
      </div>
      <div class="btn_container download_report">
        <button @click="downloadAttemptsAsCsv('pending')">
          <span class="fa fa-download" aria-hidden="true"></span>
           Constructed Responses Grading Needed
        </button>
      </div>

      <div class="btn_container download_report">
        <button @click="openEmailReportModal">
          <span class="fa fa-email" aria-hidden="true"></span>
           Send Item Analysis Report Via Email
        </button>
      </div>
    -->

    <div class="dropdown download_report_btn" :class="{ show: isOpen }">
      <button class="btn dropdown-toggle" @click="toggleDropdown">
        <span class="fa fa-download"></span>
        <span class="ml-1">
          {{ $t('download') }}
        </span>
      </button>

      <div class="dropdown-menu" :class="{ show: isOpen }">
        <button class="dropdown-item" @click="handleDownload('ALL')">
          Constructed Responses
        </button>

        <button class="dropdown-item" @click="handleDownload('pending')">
          Constructed Responses Grading Needed
        </button>

        <button class="dropdown-item" @click="handleEmail">
          Send Item Analysis Report Via Email
        </button>
      </div>
    </div>

	  <div class="row">
      <div class="page_content_container col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <report-list></report-list>
	    </div>
	  </div>
    <div class="row" v-if="(institution.locationMapEmbbedURL &&  institution.locationMapEmbbedURL.length >5)">
      <div class="page_content_container col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <iframe :src="institution.locationMapEmbbedURL" width="640" height="480"></iframe>
      </div>
    </div>

<!-- Email Model -->

    <div class="modal_popup_container course_unlock_modal">
      <b-modal ref="emailReportModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
        <div slot="modal-header" class="header-section">
          <div class="head_txt" style="margin-top: 1px;">Item  Analysis Report</div>
          <div class="btn_container">
            <button type="button" class="btn_close" @click="closeEmailReportModal" data-dismiss="modal" aria-label="Close">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row txt_row mt-3">
            Report will send to following Emails:
        </div>
        <div class="row txt_row mt-3">
            {{institution.itemAnalysisReportEmails}}
        </div>

        <div class="row mt-4">
          <div class="col-12 btn_container" style="text-align: right;">
            <b-button @click="closeEmailReportModal">cancel</b-button>
            <b-button @click="sendReport">send report</b-button>
          </div>
        </div>
      </b-modal>
    </div>
<!-- Model End-->

  </div>
</template>

<script>
  import '../../../assets/module/css/dashboard/tfaDashboard.min.css'
  import { mapState, mapActions } from 'vuex'
  import ReportList from '../../institution/components/ReportList'

  export default {
    name: 'recruiter-report',
    components: {
      ReportList
    },
    props: [],
    data: () => {
      return {
      emails:'',
      isOpen: false
      }
    },

    mounted () {
      this.loadRecruiterDashboard()
      document.addEventListener('click', this.handleDocumentClick)
    },
    beforeDestroy () {
      document.removeEventListener('click', this.handleDocumentClick)
    },

    methods: {
      ...mapActions([
      'downloadCRAsCsv',
      'sendItemAnalysisReport'
      ]),
      toggleDropdown () {
        this.isOpen = !this.isOpen
      },
      handleDownload (type) {
        this.isOpen = false
        this.downloadAttemptsAsCsv(type)
      },
      handleEmail () {
        this.isOpen = false
        this.openEmailReportModal()
      },
      handleDocumentClick (event) {
        const dropdown = this.$el.querySelector('.dropdown')
        if (dropdown && !dropdown.contains(event.target)) {
          this.isOpen = false
        }
      },
      closeEmailReportModal (){
        this.$refs.emailReportModal.hide()
      },
      openEmailReportModal (course, unlocked) {
        this.$refs.emailReportModal.show()
      },
      async loadRecruiterDashboard () {
      },
      writeFile (data, fileName) {
        const blob = new Blob([data], {type: 'text/plain'})
        const e = document.createEvent('MouseEvents')
        let a = document.createElement('a')
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
        e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
        a.dispatchEvent(e)
      },
      notifySuccess (text) {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      },
      notifyWarning (text) {
        this.$notify({
          group: 'notify',
          type: 'warn',
          title: '',
          text: text
        })
      },
      getFormattedTime() {
          var today = new Date();
          var y = today.getFullYear();
          // JavaScript months are 0-based.
          var m = today.getMonth() + 1;
          var d = today.getDate();
          var h = today.getHours();
          var mi = today.getMinutes();
          var s = today.getSeconds();
          return y + "-" + m + "-" + d + "-" + h + "-" + mi + "-" + s;
      },
      downloadAttemptsAsCsv (type) {
      this.showLoader()
        this.downloadCRAsCsv(type).then(response => {
          let qaCsvFile = response && response.fileContents ? response.fileContents : response
          let errors = response && response.error ? response.error : ''
          let warnings = response && response.warning ? response.warning : ''
          if (!qaCsvFile || !qaCsvFile.length || qaCsvFile.length === 0) {
            return this.notifyFailure(errors)
          }
          let fileName = (type==='pending')?'CR Grading Needed':'CR Grading'

          this.writeFile(qaCsvFile, fileName + '-'+this.getFormattedTime()+'.csv')
          this.hideLoader()
          if (warnings && warnings.length > 0) {
            this.notifyWarning(warnings)
          } else {
            this.notifySuccess('Constructed Responses Successfully Exported to Csv')
          }
        })
      },
      sendReport () {
          this.sendItemAnalysisReport()
          this.$refs.emailReportModal.hide()
          this.notifySuccess('The report is being processed and emails will be sent shortly.')
      },
      showLoader () {
          if (this.$parent.$refs.loadingModal) {
            this.$parent.$refs.loadingModal.show()
          }
        },
      hideLoader () {
          if (this.$parent.$refs.loadingModal) {
            this.$parent.$refs.loadingModal.hide()
          }
        }
    },

    computed: {
      ...mapState({
        'userObj': state => state.user.userObj,
        'institution': state => state.institution.institution
      })
    }
  }
</script>

<style scoped>
    .card {
        height: calc(100vh - 200px) !important;
    }
    .card-body {
        overflow: auto !important;
    }
    .icon-activity {
        font-size: 45px !important;
    }
    .report_iframe {
      border: none;
    }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/RecruiterReport.vue